import React, { useState } from "react";

// Hooks
import { useDispatch } from "react-redux";

// Actions
import { success, failure } from "~/redux/actions/snackbar-actions";
import { cancelOrderByAdmin } from "~/redux/actions/admin-orders-actions";

// Utils
import { MESSAGES } from "~/utils/message";

// Mui Components
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { Box, CircularProgress } from "@mui/material";

// Icons
import { ModalCrossCIcon, OrderCancelCIcon } from "~/assets/images";

// Styles
import "./styles.scss";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const ActionModal = (props) => {
  const { openModal, handleCloseModal, selectedOrder, getAdminOrders } = props;
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const onSubmit = async () => {
    try {
      setLoading(true);
      const response = await dispatch(cancelOrderByAdmin(selectedOrder));
      if (response.status === 200) {
        getAdminOrders();
        dispatch(success(response.data.message));
        handleCloseModal();
      } else {
        dispatch(failure(response?.data?.message));
      }
    } catch (error) {
      dispatch(failure(error?.response?.data?.message || error?.message));
    } finally {
      setLoading(false);
    }
  };

  return (
    <BootstrapDialog
      onClose={handleCloseModal}
      aria-labelledby="customized-dialog-title"
      open={openModal}
      className="orderActionWrapper"
    >
      <IconButton
        aria-label="close"
        onClick={handleCloseModal}
        sx={{
          position: "absolute",
          right: 5,
          top: 5,
          padding: 0,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <ModalCrossCIcon />
      </IconButton>
      <DialogContent dividers className="orderModalContent">
        <img height={70} src={OrderCancelCIcon} alt="disabled" />
        <Box className="deleteHeadings">
          <Typography gutterBottom variant="h4">
            {MESSAGES.ADMIN_DASHBOARD.ORDERS.CANCEL_ORDER_MODAL.HEADING}
          </Typography>
          <Typography className="footerText">
            {MESSAGES.ADMIN_DASHBOARD.ORDERS.CANCEL_ORDER_MODAL.TITLE}
          </Typography>
        </Box>
        <Box className="cancelOrderModalBtns">
          <Button onClick={handleCloseModal}>
            {MESSAGES.ADMIN_DASHBOARD.ORDERS.CANCEL_ORDER_MODAL.CANCEL_BUTTON}
          </Button>
          <Button onClick={onSubmit}>
            {loading ? (
              <CircularProgress
                sx={{
                  color: "white",
                  width: "25px !important",
                  height: "25px !important",
                }}
              />
            ) : (
              MESSAGES.ADMIN_DASHBOARD.ORDERS.CANCEL_ORDER_MODAL.SUBMIT_BUTTON
            )}
          </Button>
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
};

export default ActionModal;
